import { IApplicationState } from '../../types/redux';

export function selectRegularInfrastructure(state: IApplicationState) {
  return state.infrastructure.regularInfrastructureItems;
}
